import React from "react";
const AboutSection = () => {
  return (

    <section id="about" class="about section-bg">
    <div class="container" data-aos="fade-up">

      <div class="row no-gutters">
        <div class="content col-xl-5 d-flex align-items-stretch">
          <div class="content">
            <h3>Progress Solution</h3>
            <p>
            Progress Solution is an electronics repair place specializing in
            Laptop and Computer repairs. We are known for our advanced
            Micro-soldering services, Motherboard repairs and others.
            </p>
          </div>
        </div>
        <div class="col-xl-7 d-flex align-items-stretch">
          <div class="icon-boxes d-flex flex-column justify-content-center">
            <div class="row">
              <div class="col-md-12 icon-box" data-aos="fade-up" data-aos-delay="200">
                <i class="bx bx-cube-alt"></i>
                <h4>Experience</h4>
                <p>I would like to inform you also that I am highly skilled in chip-level repairing. Above the beyond, I have a great passion for hardware technology as well. I have worked with some hardware companies and enjoyed the work.</p>
              </div>
              <div class="col-md-6 icon-box" data-aos="fade-up" data-aos-delay="300">
                <i class="bx bx-images"></i>
                <h4>Microsoft Certified</h4>
                <p>I've Certified in Microsoft Certified System Administrator (MCSA) in 2009  </p>
              </div>
              <div class="col-md-6 icon-box" data-aos="fade-up" data-aos-delay="400">
                <i class="bx bx-shield"></i>
                <h4>Since 2015</h4>
                <p>We are providing Laptop chip level service in local area since 2015</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>

    // <section id="about" class="about">
    //   <div class="container">
    //     <div class="section-title">
    //       <h2>About Us</h2>
    //       <h5>
    //         Progress Solution is an electronics repair place specializing in
    //         Laptop and Computer repairs. We are known for our advanced
    //         Micro-soldering services, Motherboard repairs and others.
    //       </h5>
    //     </div>

    //     <div class="row content">
    //       <div class="col-lg-12">
    //         <h5 className="mb-4">
    //           We do everything from basic device screen replacements, to
    //           advanced No-Power motherboard repairs. Most of the advanced
    //           micro-soldering repairs that we do are not something done by your
    //           average repair shop.
    //         </h5>
    //       </div>

    //       <div class="row content mt-10">
    //         <div class="col-lg-12">
    //           <h4>We repairs all device from major brand!</h4>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </section>
  );
};

export default AboutSection;
